import * as React from 'react'
import { useState } from 'react'

import { Box, Button } from '@factorialco/deprecated-design-system'

import Sidepanel from 'modules/core/components/Sidepanel'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useEffect } from 'modules/core/hooks/useEffect'
import i18n from 'modules/core/lib/i18n'

import { useHapiElementsContext } from 'modules/ats/components/HapiElementsLoader'
import { resetOrderJourney } from 'modules/ats/lib/vonq'
import { VonqCampaignForm } from 'modules/ats/pages/JobPostingPromotion/JobBoards/Providers/Vonq/Forms'
import type Job from 'modules/ats/store/models/Job'
import { useCompanyPageSettings } from 'modules/company_page/hooks/useCompanyPageSettings'

import { getMappedJobToHapiElementsCampaignForm } from './getMappedJobToHapiElementsCampaignForm'

interface Props {
  job: Job
}

export const VonqCampaignCheckout = ({ job }: Props) => {
  // TODO: Think about having the urls in the job
  const { buildUrl } = useCompanyPageSettings()
  const { elementsLoaded, clientId } = useHapiElementsContext()
  const [contractsCount, setContractsCount] = useState(0)
  const [checkoutSidepanelOpen, setCheckoutSidepanelOpen] = React.useState(false)

  const {
    access: { fullName: accessFullName },
    email: accessEmail,
  } = useCurrentSession()

  // Update the basket products count when the basket changes
  useEffect(() => {
    if (!elementsLoaded) {
      return
    }

    window.hapi.campaign.state.campaignForm = {
      ...window.hapi.campaign.state.campaignForm.value,
      companyId: clientId,
      ...getMappedJobToHapiElementsCampaignForm(job, buildUrl),
      recruiterInfo: {
        name: accessFullName,
        emailAddress: accessEmail,
      },
      labels: {
        factorialJobId: job.id.toString(),
      },
    }

    window.hapi.campaign.state.campaignForm.onChange((newValue: VonqCampaignForm) => {
      window.hapi.campaign.state.campaignForm = {
        ...newValue,
        companyId: clientId,
        labels: {
          factorialJobId: job.id.toString(),
        },
      }
    })

    setContractsCount(window.hapi.basket.state?.productsMeta.value.length)

    window.hapi.basket.state?.productsMeta.onChange((newValue: unknown[]) => {
      setContractsCount(newValue.length)
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [elementsLoaded, job.id])

  return (
    <>
      <Button
        type="primary"
        onClick={() => setCheckoutSidepanelOpen(true)}
        disabled={contractsCount === 0}
      >
        {i18n.t('ats.vonq.contracts_list.cart_button', { count: contractsCount })}
      </Button>

      {checkoutSidepanelOpen && (
        <CheckoutSidepanel job={job} onClose={() => setCheckoutSidepanelOpen(false)} />
      )}
    </>
  )
}

interface CheckoutSidepanelProps {
  job: Job
  onClose: () => void
}

const CheckoutSidepanel = ({ job, onClose }: CheckoutSidepanelProps) => {
  const { elementsLoaded } = useHapiElementsContext()

  // Reset the campaign form and close the sidepanel when the campaign is ordered
  useEffect(() => {
    if (!elementsLoaded) {
      return
    }

    window.hapi.campaign.service.orderCampaign.onSuccess(() => {
      onClose()
      resetOrderJourney()
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [elementsLoaded])

  return (
    <Sidepanel
      title={i18n.t('ats.vonq.campaign_checkout_sidepanel.title')}
      onClose={onClose}
      width="extended"
      boxPadding={false}
      closeLabel={i18n.t('common.close')}
      footer={
        // @ts-expect-error We're importing a webcomponet without types
        <he-userjourney-buttons></he-userjourney-buttons>
      }
      open
    >
      <Box height="full">
        {/* @ts-expect-error We're importing a webcomponet without types */}
        <he-orderjourney-checkout-shorter></he-orderjourney-checkout-shorter>
      </Box>
    </Sidepanel>
  )
}
